import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDebouncedAction } from "../../../../../../helpers/commonFunction";
import { AppState } from "../../../../../../stateManager/store";
import { getValue, getComponents } from "../../helpers";

import { onChange } from "./helpers/on-change"

const DEFAULT_ZINDEX: string = "properties.styles.$deviceType.zIndex";

type Props = {
  label: string;
  isCheckedIn: boolean;
  defaultValue?: string;
}

export const ZIndex = (props: Props) => {
  const { components } = getComponents()
  const { selectedElementId, deviceType, computedStyles, wrapperComputedStyles, isCoreV3 } = useSelector((state: AppState) => state.formJson)
  const { isCheckedIn, defaultValue, label } = props;
  const [oldValue, setOldValue] = useState<string>("");
  const [value, setValue] = useDebouncedAction(defaultValue, 500 || "");
  const component = components[selectedElementId];

  useEffect(() => {
    if (isCoreV3 && component) {
      const previousValue = getValue(component, DEFAULT_ZINDEX.split("."), deviceType);
      if (previousValue) {
        setValue(previousValue);
        setOldValue(previousValue);
      } else if (computedStyles.zIndex) {
        setValue(computedStyles.zIndex);
        setOldValue(computedStyles.zIndex);
      } else {
        setValue("");
        setOldValue("");
      }
    } else if (!isCoreV3 && component) {
      const previousValue = getValue(component, DEFAULT_ZINDEX.split("."), deviceType);
      if (previousValue) {
        setValue(previousValue)
        setOldValue(previousValue)
      }
    }
    // eslint-disable-next-line
  }, [isCoreV3, component, deviceType, computedStyles]);

  return (
    <div className="panel-div">
      <label
        htmlFor="horizontal"
        className="panel-label"
      >
        {label}
      </label>
      <input
        style={{ cursor: !isCheckedIn ? "not-allowed" : "auto" }}
        disabled={!isCheckedIn}
        type="number"
        id="zIndex"
        value={value}
        className="panel-input"
        placeholder="0"
        onChange={e => {
          const value = e.target.value;
          setValue(value, () => onChange({
            path: DEFAULT_ZINDEX,
            value,
            oldValue,
            setOldValue,
            selectedElementId
          }))
        }}
      />
    </div>
  )
};
